import React, { useContext } from "react";
import { OpenContext } from "../App";


const Header = ({ children }) => {
  const { open } = useContext(OpenContext);
  return (
    <header
      id="header"
      className={`header shadow-lg `}
      style={{
        width: open ? `calc(100% - 224px)` : `calc(100% - 68px)`,
        padding: "0 20px",
        right: 0
      }}
    >
      {children}
    </header>
  );
};
// const Header = (props) => {

//     const { open } = props;

//     return <header
//         id="header"
//         className={`header shadow-lg ${open ? "body-pd" : ""}`}
//         style={{ width: !open ? `calc(100vw - 58px)` : `calc(100vw - 224px)`, right: 0 }}
//     >
//         {props.children}
//     </header>
// }

export default Header